import React from 'react'
import classNames from 'classnames'

import { DataLoader } from './ResidentNotificationsDataLoader'
import { ErrorHandler } from './ResidentNotificationsErrorHandler'
import {
  ContractType,
  ResidentNotificationCategory,
} from '../../../common/types'
import ResidentNotification from '../ResidentNotification'

interface ResidentNotificationsProps {
  categories?: ResidentNotificationCategory[]
  className?: string
  contractType?: ContractType
}

export const ResidentNotifications: React.FC<ResidentNotificationsProps> = ({
  categories,
  className,
  contractType,
}) => {
  return (
    <div className={classNames('phone:px-4', className)}>
      <ErrorHandler>
        <DataLoader notificationCategories={categories}>
          {({ notifications, userMetadata }) =>
            notifications.length ? (
              <div className="flex flex-col tablet:flex-row flex-wrap gap-2 max-tablet:my-4">
                {notifications.map((notification) => (
                  <ResidentNotification
                    key={notification.id}
                    notification={notification}
                    userMetadata={userMetadata}
                    contractType={contractType}
                  />
                ))}
              </div>
            ) : null
          }
        </DataLoader>
      </ErrorHandler>
    </div>
  )
}
